Vue.component('commodity-adder', {
    props: ['assessment'],
    data() {
        return {
            loading : false,
            search : null,
            pagination : {},
            currentPage : 1,
        }
    },
    computed: {
        //
    },
    methods: {
        loadCommodities() {
            this.loading = true;
            axios.get('/commodities', {params : { search : this.search, page : this.currentPage }})
                 .then(response => {
                    this.pagination = response.data;
                    this.loading = false;
                 });
        },
        applySearch() {
            this.currentPage = 1;
            this.loadCommodities();
        },
        addCommodity(commodity) {
            var assessmentCommodity = {
                id : null,
                country_of_origin : null,
                amount : null,
                commodity : {
                    id : commodity.id,
                    name : commodity.name,
                    commodity_processes : commodity.commodity_processes,
                }
            }

            this.assessment.assessment_commodities.push(assessmentCommodity);
            $('#commodityAdderModal').modal('toggle');
        },
        goToPage(page) {
            this.currentPage = page;
            this.loadCommodities();
        },
        goToNextPage() {
            if (this.currentPage >= this.pagination.last_page) {
                return;
            }

            this.goToPage(this.currentPage + 1);
        },
        goToPrevPage() {
            if (this.currentPage == 0) {
                return;
            }

            this.goToPage(this.currentPage - 1);
        }
    },
    mounted() {
        this.loadCommodities();
    }
});
